var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "w-100 popupmodal position-fixed p-3",
      class: [
        _vm.popupmodalActive ? "open" : "",
        _vm.theme == "white" ? "text-dark" : "text-white",
      ],
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-100 position-relative popupmodal__inner d-flex align-items-center justify-content-center",
          class: [
            _vm.theme == "dark"
              ? "bg-fourth-" + _vm.theme
              : "bg-specialbackground-" + _vm.theme,
          ],
        },
        [
          _c(
            "svg",
            {
              staticClass: "erroricon",
              attrs: {
                "clip-rule": "evenodd",
                "fill-rule": "evenodd",
                height: "32",
                "image-rendering": "optimizeQuality",
                "shape-rendering": "geometricPrecision",
                "text-rendering": "geometricPrecision",
                viewBox: "0 0 254000 254000",
                width: "32",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("g", { attrs: { id: "图层_x0020_1" } }, [
                _c("path", {
                  attrs: {
                    d: "m127000 0c70129 0 127000 56871 127000 127000s-56871 127000-127000 127000-127000-56871-127000-127000 56871-127000 127000-127000zm-64190 172969 45969-45969-45969-45969c-2637-2638-2637-6941 0-9578l8643-8643c2637-2637 6940-2637 9578 0l45969 45969 45969-45969c2638-2637 6941-2637 9578 0l8643 8643c2637 2637 2637 6940 0 9578l-45969 45969 45969 45969c2637 2638 2637 6941 0 9578l-8643 8643c-2637 2637-6940 2637-9578 0l-45969-45969-45969 45969c-2638 2637-6941 2637-9578 0l-8643-8643c-2637-2637-2637-6940 0-9578z",
                    fill: [_vm.theme == "dark" ? "#FDC300" : "#c80000"],
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "pl-5" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.popupMessage) } }, [
              _vm._v(
                "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet."
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close", on: { click: _vm.closePopup } }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 512 512",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("g", { attrs: { id: "_02_User", "data-name": "02 User" } }, [
                  _c("path", {
                    attrs: {
                      fill: [_vm.theme == "dark" ? "#FFF" : "#000"],
                      d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      fill: [_vm.theme == "dark" ? "#FFF" : "#000"],
                      d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                    },
                  }),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }